import styled from "styled-components";

export const CellDescDiv = styled.div`
    display: flex;
    align-items: center;
    div {
        margin: 0 3px;
    }

`